import React, { useState } from 'react';

import { Row } from 'react-table';

import { getWebpackEnvVar, locale } from '@trqk/utils';
import { LeftNavHeader, LogsTable, JsonViewer } from '@trqk/components';

import { WebLayout } from '../../templates';
import { useLogData } from '../../../hooks';

/**
 * Displays a table of log events for the current user. When a row in the table is clicked, the
 * full details of the log event are fetched and displayed in a code window. This is an internal
 * tool that is exposed through the Account menu with a featureFlag on dev and staging.
 */
export const ClientEvents = (): JSX.Element => {
    const bucketName = getWebpackEnvVar('web', 'AWS_S3_LOGS_BUCKET');
    const bucketRegion = getWebpackEnvVar('web', 'AWS_REGION');
    const identityPoolId = getWebpackEnvVar('web', 'AWS_IDENTITY_POOL_ID');
    const [selected, setSelected] = useState<Row<LogEvent> | null>(null);
    const { logs, userId } = useLogData();

    return (
        <WebLayout
            mainWidth={null}
            headerPadding="xs"
            header={{
                content: (
                    <LeftNavHeader>
                        <h3>{locale.enUS.CLIENT_EVENTS.TITLE}</h3>
                        <h4>User ID: {userId}</h4>
                    </LeftNavHeader>
                ),
            }}
        >
            <div className="flex w-full">
                <div className="flex-none">
                    <LogsTable
                        logRows={logs}
                        selected={selected}
                        setSelected={setSelected}
                    />
                </div>
                <div className="flex-grow">
                    {selected && (
                        <>
                            <h4 className="ml-4">Event Details</h4>
                            <JsonViewer
                                bucketName={bucketName}
                                bucketRegion={bucketRegion}
                                identityPoolId={identityPoolId}
                                selected={selected}
                            />
                        </>
                    )}
                </div>
            </div>
        </WebLayout>
    );
};
